import { render, staticRenderFns } from "./ed-class-builder-schedule.component.vue?vue&type=template&id=83db2e84&scoped=true&"
import script from "./ed-class-builder-schedule.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-builder-schedule.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-builder-schedule.component.scss?vue&type=style&index=0&id=83db2e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83db2e84",
  null
  
)

export default component.exports